<template><div><dt-notice kind="warning" title="Use DtStack in favor of Flex CSS Utilities" :show-close="false" class="d-wmx100p d-my-200 dialtone-doc-notice">
Use the <a href="/components/stack" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">DtStack</a> component for most Flex-based layout implementations. View <a href="/about/whats-new/posts/2025-12-2" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Migrating from Flex CSS Utilities to DtStack</a> for more details.
</dt-notice>
<h2 id="example" tabindex="-1" class="d-docsite--header-2">Example <a class="header-anchor d-link d-docsite--link d-link" href="#example" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">By default, items are ordered by their position in the DOM. To re-order an element, use <code v-pre>d-order{#}</code>.</p>
<code-example source-code='&lt;dt-stack direction=&quot;row&quot; gap=&quot;200&quot; align=&quot;center&quot; justify=&quot;between&quot; class=&quot;d-w100p d-bar-400 d-bgc-moderate&quot;&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200 d-size-100 d-bgc-moderate-opaque d-bar-300&quot;&gt;1&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200 d-size-100 d-bgc-moderate-opaque d-bar-300&quot;&gt;2&lt;/dt-stack&gt;
  &lt;dt-stack direction=&quot;row&quot; align=&quot;center&quot; justify=&quot;center&quot; class=&quot;d-p-200 d-size-100 d-bgc-bold-opaque d-bar-300 d-order-first&quot;&gt;3&lt;/dt-stack&gt;
&lt;/dt-stack&gt;'>
<dt-stack direction="row" gap="200" align="center" justify="between" class="d-w100p d-bar-400 d-bgc-moderate">
  <dt-stack direction="row" align="center" justify="center" class="d-p-200 d-size-100 d-bgc-moderate-opaque d-bar-300">1</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-p-200 d-size-100 d-bgc-moderate-opaque d-bar-300">2</dt-stack>
  <dt-stack direction="row" align="center" justify="center" class="d-p-200 d-size-100 d-bgc-bold-opaque d-bar-300 d-order-first">3</dt-stack>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, '-first', '-last']">
        <th scope="row" class="d-code--sm d-docsite-code">.d-order{{ i }}</th>
        <td class="d-code--sm">
          order:
          <span v-if="i === '-first'">-9999</span>
          <span v-else-if="i === '-last'">9999</span>
          <span v-else>{{ i }}</span>
          !important;
        </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


